import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { IndividuService } from '@Common/core/services';
import { Observable } from 'rxjs';
import {roles} from '../enum/roles';


@Injectable()
export class AdminGuardService  {
  constructor(private individuService: IndividuService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.isAdmin();
  }

  private isAdmin(): Observable<boolean> {
    return new Observable(observer => {
      this.individuService.individu$.subscribe(_individu => {
        observer.next(this._isAdmin(_individu));
        observer.complete();
      });
    });
  }

  private _isAdmin(individu) {
    if (this.individuService.hasRole(individu,  roles.admin)) {
      return true;
    } else {
      this.router.navigateByUrl('/forbidden');
      return false;
    }
  }
}
